import { INSPIRATIONAL_QUOTES } from '../FeatureShowcase/features'
import styles from './InspirationalQuote.module.css'

interface InspirationalQuoteProps {
  isVisible: boolean
  currentQuoteIndex: number
}

export function InspirationalQuote({ isVisible, currentQuoteIndex }: InspirationalQuoteProps) {
  const currentQuote = INSPIRATIONAL_QUOTES[currentQuoteIndex % INSPIRATIONAL_QUOTES.length]

  return (
    <div className={`${styles.quoteContainer} ${isVisible ? styles.visible : ''}`}>
      <p className={styles.quoteText}>{currentQuote}</p>
    </div>
  )
}
